export const api_key = "CNCPYHiDfuYLqqai8zAG";
export const secret_key = "MSO09gJTLAaYiEzdaRFzGHc1UTrLrgjm0Cyy4MWS";
export const sdkURL = (url = "") => new URL(url, "https://saas-sdk-stage.carenow.healthcare");
